import * as React from "react";
import { Spinner } from "./spinner";

export interface ButtonProps {
  readonly label: string;
  readonly type?: "primary" | "secondary" | "danger";
  readonly onClick?: () => void;
  readonly disabled?: boolean;
  readonly className?: string;
  readonly spinner?: boolean;
}

export function Button(props: ButtonProps): React.ReactElement<ButtonProps> {
  const style = props.type || "primary";
  let className = "cursor-pointer btn btn-xs text-xs space-x-8";
  switch (style) {
    case "primary":
      className += " btn-primary";
      break;
    case "secondary":
      className += " btn-secondary";
      break;
    case "danger":
      className += " btn-error";
      break;
    default:
      break;
  }
  if (props.disabled) {
    className += " btn-disabled";
  }
  if (props.className) {
    className += ` ${props.className}`;
  }
  return (
    <div>
      <a
        className={className}
        onClick={() => {
          if (!props.disabled && props.onClick) {
            props.onClick();
          }
        }}
      >
        {props.spinner && <Spinner disableDebounce={true} />}
        <span>{props.label}</span>
      </a>
    </div>
  );
}
